import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SelectedTab } from '../../../shared/models/selected-tab';

@Injectable({ providedIn: 'root' })
export class SelectedTabService {

  private selectedTabSource = new Subject<SelectedTab>();
  public selectedTab$ = this.selectedTabSource.asObservable();

  public selectedTabData(tab: SelectedTab) {
    this.selectedTabSource.next(tab);
  }
}